<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="平均心率(次/分钟)" prop="heartRate" >
        <a-input v-model="form.heartRate" placeholder="请输入平均心率(次/分钟)" />
      </a-form-model-item>
      <a-form-model-item label="最高心率(次/分钟)" prop="maxHeartRate" >
        <a-input v-model="form.maxHeartRate" placeholder="请输入最高心率(次/分钟)" />
      </a-form-model-item>
      <a-form-model-item label="最低心率(次/分钟)" prop="minHeartRate" >
        <a-input v-model="form.minHeartRate" placeholder="请输入最低心率(次/分钟)" />
      </a-form-model-item>
      <a-form-model-item label="频率(Hz)" prop="frequency" >
        <a-input v-model="form.frequency" placeholder="请输入频率(Hz)" />
      </a-form-model-item>
      <a-form-model-item label="走速(mm/s)" prop="walkingSpeed" >
        <a-input v-model="form.walkingSpeed" placeholder="请输入走速(mm/s)" />
      </a-form-model-item>
      <a-form-model-item label="增益(mm/mv)" prop="gain" >
        <a-input v-model="form.gain" placeholder="请输入增益(mm/mv)" />
      </a-form-model-item>
      <a-form-model-item label="心率变异性HRV(毫秒)" prop="hrv" >
        <a-input v-model="form.hrv" placeholder="请输入心率变异性HRV(毫秒)" />
      </a-form-model-item>
      <a-form-model-item label="心电图PWV(m/s)" prop="pwv" >
        <a-input v-model="form.pwv" placeholder="请输入心电图PWV(m/s)" />
      </a-form-model-item>
      <a-form-model-item label="心电图QTC(毫秒)" prop="qtc" >
        <a-input v-model="form.qtc" placeholder="请输入心电图QTC(毫秒)" />
      </a-form-model-item>
      <a-form-model-item label="心电图QRC波振幅(mv)" prop="qrsWaveAmplitude" >
        <a-input v-model="form.qrsWaveAmplitude" placeholder="请输入心电图QRC波振幅(mv)" />
      </a-form-model-item>
      <a-form-model-item label="心电图QRC波时限(毫秒)" prop="qrsWaveTime" >
        <a-input v-model="form.qrsWaveTime" placeholder="请输入心电图QRC波时限(毫秒)" />
      </a-form-model-item>
      <a-form-model-item label="心电图QRC主波方向(0-向上  1-向下)" prop="qrsWaveDirection" >
        <a-input v-model="form.qrsWaveDirection" placeholder="请输入心电图QRC主波方向(0-向上  1-向下)" />
      </a-form-model-item>
      <a-form-model-item label="心电图ST段振幅(mV)" prop="st" >
        <a-input v-model="form.st" placeholder="请输入心电图ST段振幅(mV)" />
      </a-form-model-item>
      <a-form-model-item label="疾病风险" prop="diseaseRisk" >
        <a-input v-model="form.diseaseRisk" placeholder="请输入疾病风险" />
      </a-form-model-item>
      <a-form-model-item label="压力指数" prop="pressureIndex" >
        <a-input v-model="form.pressureIndex" placeholder="请输入压力指数" />
      </a-form-model-item>
      <a-form-model-item label="疲劳指数" prop="fatigueIndex" >
        <a-input v-model="form.fatigueIndex" placeholder="请输入疲劳指数" />
      </a-form-model-item>
      <a-form-model-item label="心肌炎风险" prop="myocarditisRisk" >
        <a-input v-model="form.myocarditisRisk" placeholder="请输入心肌炎风险" />
      </a-form-model-item>
      <a-form-model-item label="冠心病风险" prop="coronaryHeartDisease" >
        <a-input v-model="form.coronaryHeartDisease" placeholder="请输入冠心病风险" />
      </a-form-model-item>
      <a-form-model-item label="血管硬化风险" prop="angiosclerosisRisk" >
        <a-input v-model="form.angiosclerosisRisk" placeholder="请输入血管硬化风险" />
      </a-form-model-item>
      <a-form-model-item label="波形报告ppt路径" prop="wavePpt" >
        <a-input v-model="form.wavePpt" placeholder="请输入波形报告ppt路径" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEcg, addEcg, updateEcg } from '@/api/joe/ecg'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        heartRate: null,

        maxHeartRate: null,

        minHeartRate: null,

        frequency: null,

        walkingSpeed: null,

        gain: null,

        hrv: null,

        pwv: null,

        qtc: null,

        qrsWaveAmplitude: null,

        qrsWaveTime: null,

        qrsWaveDirection: null,

        st: null,

        diseaseRisk: null,

        pressureIndex: null,

        fatigueIndex: null,

        myocarditisRisk: null,

        coronaryHeartDisease: null,

        angiosclerosisRisk: null,

        wavePpt: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        heartRate: null,
        maxHeartRate: null,
        minHeartRate: null,
        frequency: null,
        walkingSpeed: null,
        gain: null,
        hrv: null,
        pwv: null,
        qtc: null,
        qrsWaveAmplitude: null,
        qrsWaveTime: null,
        qrsWaveDirection: null,
        st: null,
        diseaseRisk: null,
        pressureIndex: null,
        fatigueIndex: null,
        myocarditisRisk: null,
        coronaryHeartDisease: null,
        angiosclerosisRisk: null,
        wavePpt: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getEcg({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEcg(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEcg(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
